// extracted by mini-css-extract-plugin
export default {"container":"DeletionCompleteModalBody_container__mge-s","checkIcon":"DeletionCompleteModalBody_checkIcon__rg+5u"};